import { useState } from 'react';
import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    name: '',
    listOfProducts: []
};

const CartReducer = createSlice({
    name: 'routerPage',
    initialState: initialState,
    reducers: {
        updateRoute(state, action) {
            state= state.listOfProducts.push(action.payload);
        },
        removeItems(state, action) {
            state = state.listOfProducts.splice(action.payload, 1);
        }
    }
});

export const { updateRoute, removeItems } = CartReducer.actions;
export default CartReducer.reducer;